// src/locales/upload-document-en.ts
export default {
    upload: {
        // Header
        title: "Upload New Document",
        subtitle: "Share knowledge and earn from your documents",

        // Progress steps
        steps: {
            basicInfo: "Basic Info",
            fileUpload: "File Upload",
            pricing: "Pricing",
            advanced: "Advanced",
            review: "Review"
        },

        // Basic Info Tab
        basicInfo: {
            title: "Document Information",
            subtitle: "Provide basic information about your document",

            documentTitle: "Document Title",
            titlePlaceholder: "Enter document title...",
            titleHelp: "A clear title helps your document become more discoverable",

            description: "Description",
            descriptionPlaceholder: "Provide detailed description of the document content...",
            descriptionHelp: "A detailed description helps readers understand the content and decide whether to purchase",

            documentType: "Document Type",
            documentCategory: "Category",
            subject: "Subject",
            educationLevel: "Education Level",
            language: "Language",
            publicationDate: "Publication Date",

            languages: {
                vietnamese: "Vietnamese",
                english: "English",
                french: "French",
                japanese: "Japanese",
                chinese: "Chinese"
            }
        },

        // File Upload Tab
        fileUpload: {
            title: "Upload Files",
            subtitle: "Select document file and cover image",

            selectFile: "Select Document File",
            dragDrop: "Drag and drop file or click to select",
            supportedFormats: "Supported formats",
            maxSize: "Maximum size",
            selectedFile: "Selected file",
            fileSize: "File size",

            coverImage: "Cover Image",
            coverImageHelp: "An attractive cover will get more views",
            recommendedSize: "Recommended size: 1200 x 1600 pixels (3:4 ratio)",

            keywords: "Keywords",
            keywordsPlaceholder: "Enter keywords...",
            keywordsHelp: "Example: mathematics, algebra, equations, grade 10",
            addKeyword: "Add Keyword",
            maxKeywords: "Maximum 10 keywords"
        },

        // Pricing Tab
        pricing: {
            title: "Pricing & Sharing",
            subtitle: "Set pricing and profit sharing",

            pricingModel: "Pricing Model",
            freeDocument: "Free Document",
            paidDocument: "Paid Document",

            price: "Price (VND)",
            pricePlaceholder: "Enter document price",
            platformFee: "Platform fee: 20%",
            yourEarning: "You'll receive",

            visibility: "Visibility",
            publicDocument: "Public",
            privateDocument: "Private",
            publicDescription: "Everyone can find and view this document",
            privateDescription: "Only you and shared users can view this document",

            coAuthors: "Co-authors",
            coAuthorsHelp: "Share copyright and profits with co-authors",
            authorEmail: "Co-author Email",
            sharePercentage: "Share Percentage",
            addCoAuthor: "Add Co-author",
            removeCoAuthor: "Remove",
            totalShare: "Total Percentage",
            maxShare: "Total cannot exceed 100%"
        },

        // Advanced Tab
        advanced: {
            title: "Advanced Settings",
            subtitle: "Configure security and access permissions",

            previewOptions: "Preview Options",
            enablePreview: "Enable Preview",
            previewPages: "Preview Pages",
            previewHelp: "Users can view first few pages for free",

            drmOptions: "Digital Rights Management (DRM)",
            enableDRM: "Enable DRM Protection",
            drmHelp: "Prevent unauthorized copying and printing",
            allowPrinting: "Allow Printing",
            allowCopying: "Allow Text Copying",
            expiryDays: "Expires After (days)",
            expiryHelp: "0 = never expires",

            additionalOptions: "Additional Options",
            addWatermark: "Add Watermark",
            watermarkHelp: "Add copyright protection watermark",
            requireSubscription: "Require Subscription",
            subscriptionHelp: "Only subscribed members can access",
            copyrightRegistered: "Copyright Registered",
            copyrightHelp: "Document has official copyright registration"
        },

        // Review Tab
        review: {
            title: "Review Information",
            subtitle: "Review all information before uploading",

            documentInfo: "Document Information",
            fileInfo: "File Information",
            pricingInfo: "Pricing Information",
            advancedInfo: "Advanced Settings",

            confirmUpload: "Confirm Upload",
            termsAgreement: "I confirm this document doesn't violate copyright and agree to Terms of Service",
            publishAfterReview: "Publish after approval",
            saveAsDraft: "Save as draft",
            reviewTime: "Document will be reviewed within 24 hours"
        },

        // Actions
        actions: {
            next: "Next",
            previous: "Previous",
            cancel: "Cancel",
            upload: "Upload",
            uploading: "Uploading...",
            preview: "Preview",
            saveDraft: "Save Draft",
            publish: "Publish"
        },

        // Progress
        progress: {
            uploading: "Uploading",
            processing: "Processing",
            completed: "Completed",
            cancel: "Cancel Upload"
        },

        // Messages
        messages: {
            success: "Document uploaded successfully!",
            successDesc: "Your document is being reviewed and will be published soon",
            redirecting: "Redirecting...",
            uploadError: "An error occurred while uploading",
            invalidFile: "Invalid file",
            fileTooLarge: "File too large",
            networkError: "Network connection error"
        },

        // Validation
        validation: {
            required: "This field is required",
            minLength: "Minimum {{min}} characters",
            maxLength: "Maximum {{max}} characters",
            minPrice: "Minimum price {{min}} VND",
            maxPrice: "Maximum price {{max}} VND",
            invalidEmail: "Invalid email address",
            invalidFile: "Invalid file",
            maxFileSize: "Maximum file size {{max}}MB",
            minPages: "Minimum {{min}} pages",
            maxPages: "Maximum {{max}} pages",
            minDays: "Minimum {{min}} days",
            maxDays: "Maximum {{max}} days"
        }
    }
};